// Phase 34c.3 — investor portal summary tile.
//
// Premium primitive that the four hero cards on /investor compose. Variants
// expose an accent ring + tinted icon background so the row reads as a
// gradient of intent: indigo (committed) → sky (contributed) → emerald
// (pref) → violet (capital returned).

import { cn } from "@/lib/utils";

const ACCENTS = {
  indigo:  { icon: "bg-indigo-50 text-indigo-700",   ring: "ring-indigo-100" },
  sky:     { icon: "bg-sky-50 text-sky-700",         ring: "ring-sky-100" },
  emerald: { icon: "bg-emerald-50 text-emerald-700", ring: "ring-emerald-100" },
  violet:  { icon: "bg-violet-50 text-violet-700",   ring: "ring-violet-100" },
};

export default function SummaryCard({
  testid,
  icon: Icon,
  accent = "indigo",
  label,
  value,
  hint,
}) {
  const palette = ACCENTS[accent] || ACCENTS.indigo;
  return (
    <div
      data-testid={testid}
      className={cn(
        "group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm",
        "transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md",
        "ring-1 ring-transparent hover:ring-2 hover:ring-offset-0",
        `hover:${palette.ring}`,
      )}
    >
      <div className="flex items-start justify-between">
        <div className="text-xs font-medium uppercase tracking-wider text-slate-500">
          {label}
        </div>
        <div className={cn("rounded-full p-2.5", palette.icon)}>
          <Icon className="h-4 w-4" />
        </div>
      </div>
      <div className="mt-3 text-3xl font-bold tracking-tight text-slate-900 tabular-nums">
        {value}
      </div>
      {hint ? (
        <div className="mt-1.5 text-xs text-slate-500">{hint}</div>
      ) : null}
    </div>
  );
}
